import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var UserLookupService = /** @class */ (function () {
    function UserLookupService(apollo) {
        this.apollo = apollo;
    }
    UserLookupService.prototype.lookupUserByEmail = function (email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.query({
                        query: gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        query userLookup($email: String!){\n          userLookup(email: $email) {\n            code\n            email\n            name\n            loginIntegrationEnabled\n            loginProvider\n            slug\n            clientId\n            tenantId\n            openIdConfigurationEndpoint\n          }\n        }\n      "], ["\n        query userLookup($email: String!){\n          userLookup(email: $email) {\n            code\n            email\n            name\n            loginIntegrationEnabled\n            loginProvider\n            slug\n            clientId\n            tenantId\n            openIdConfigurationEndpoint\n          }\n        }\n      "]))),
                        variables: { email: email }
                    })
                        .toPromise()
                        .then(function (result) { return result.data['userLookup']; })];
            });
        });
    };
    UserLookupService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserLookupService_Factory() { return new UserLookupService(i0.ɵɵinject(i1.Apollo)); }, token: UserLookupService, providedIn: "root" });
    return UserLookupService;
}());
export { UserLookupService };
var templateObject_1;
